import { print } from "graphql";
import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Pagination } from './pagination';
import { Funcionalidade, PageFuncionalidadeInput } from '@/models/funcionalidade';
import { Empresa, PageEmpresaInput } from '@/models/empresa';

const companiesPage = require('@/query/empresa/Page.graphql')

export class EmpresaAPI extends BaseAPI<Empresa> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1/companies/`
  }

  public list(params: any): AxiosObservable<Empresa[]> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }

  public show(id: number): AxiosObservable<Empresa> {
    return this.axios.get(`${this.apiUrl}${id}`)
  }

  public update(id: number, body: any): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}${id}`, body)
  }

  public create(body: any): AxiosObservable<Empresa> {
    return this.axios.post(`${this.apiUrl}`, body)
  }

  public token(id: number): AxiosObservable<{ token: string }> {
    return this.axios.get(`${this.apiUrl}${id}/token`)
  }
}
